/**
 * Note: We keep track of the number of visits a step receives because some steps have
 * a can receive maximum number of visits. For example the recurringNudge step
 */
export const INITIAL_NUM_VISITS = 0

/**
 * Note: Each step is created by a factory function, but the index it's given is initially
 * invalid because the actual index is calculated dynamically eventually.
 */
export const INITIAL_INVALID_STEP_INDEX = -1

/**
 * Enum representing the different layout types available in the flow.
 * - `OneColumn`: Indicates that the step should use a one-column layout.
 * - `TwoColumn`: Indicates that the step should use a two-column layout.
 *
 * This enum helps ensure type safety and consistency when selecting the layout for each step.
 */
export enum LayoutType {
  OneColumn = 'one-column',
  TwoColumn = 'two-column',
}

/**
 * Enum representing the different types of right panels available in the flow.
 *
 * - `SocialPanel`: Represents the SocialPanel component, which can be displayed
 *   on the right side of the layout.
 *
 * This enum ensures that only serializable data is stored in the Redux state.
 * It is used to dynamically render the appropriate right panel component.
 */
export enum RightPanelType {
  SocialPanel = 'social-panel',
}
